import { render, staticRenderFns } from "./account-automation.vue?vue&type=template&id=3acfd464&scoped=true"
import script from "./account-automation.vue?vue&type=script&lang=js"
export * from "./account-automation.vue?vue&type=script&lang=js"
import style0 from "./account-automation.vue?vue&type=style&index=0&id=3acfd464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfd464",
  null
  
)

export default component.exports